import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

function LeaveHistory({ historyData, operation, colors }) {
  return (
    <Box
      sx={{
        backgroundColor: colors.primary[400],
        p: "20px",
        borderRadius: "4px",
        mt: "20px",
        maxWidth: "800px",
        mx: "auto"
      }}
    >
      <Typography variant="h3" sx={{ mb: "20px", color: colors.grey[100], textAlign: "center" }}>
        {operation} Leave History
      </Typography>
      <TableContainer sx={{ backgroundColor: colors.primary[400], borderRadius: "4px" }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ 
              backgroundColor: colors.blueAccent[700],
              '& .MuiTableCell-root': {
                padding: '4px 8px',
                color: colors.grey[100],
                fontWeight: "bold",
                lineHeight: '4',
              }
            }}>
              <TableCell>Operation</TableCell>
              <TableCell>Leave Type</TableCell>
              <TableCell>Value</TableCell>
              <TableCell>Total After</TableCell>
              <TableCell>Comment</TableCell>
              <TableCell>Timestamp</TableCell>
              <TableCell>Updated By</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {historyData.map((row, index) => (
              <TableRow 
                key={index}
                sx={{ 
                  '&:hover': { backgroundColor: colors.grey[800] },
                  '& .MuiTableCell-root': {
                    padding: '4px 8px',
                    lineHeight: '2.5',
                    color: colors.grey[100],
                  },
                  height: '50px',
                }}
              >
                <TableCell>{row.operation}</TableCell>
                <TableCell>{row.leave_type}</TableCell>
                <TableCell>{row.value}</TableCell>
                <TableCell>{row.total_after}</TableCell>
                <TableCell>{row.comment}</TableCell>
                <TableCell>{new Date(row.timestamp).toLocaleString()}</TableCell>
                <TableCell>{row.updated_by}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default LeaveHistory;